"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _reactComponents = require("@cimpress/react-components");

var _colors = require("@cimpress/react-components/lib/colors");

var _IconPencilAlt = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconPencilAlt"));

var _IconBin = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconBin"));

var _IconCopy = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconCopy"));

var _IconAlertTriangle = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconAlertTriangle"));

var _commonStyles = require("../shared/commonStyles");

var _flexStyles = require("../shared/flexStyles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   {\n    border: solid ", " 1px !important;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        padding: 0px;\n        border: none;\n        background: none;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var IconButton = function IconButton(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["className", "disabled"]);

  return (
    /*#__PURE__*/
    _react["default"].createElement("button", _extends({
      className: (0, _emotion.cx)((0, _emotion.css)(_templateObject()), 'clickable', className)
    }, rest))
  );
};

var errorBoarder = (0, _emotion.css)(_templateObject2(), _colors.warning.base);

var ConstraintCard = function ConstraintCard(_ref2) {
  var title = _ref2.title,
      content = _ref2.content,
      editing = _ref2.editing,
      onDeleteClick = _ref2.onDeleteClick,
      onEditClick = _ref2.onEditClick,
      onCopyClick = _ref2.onCopyClick,
      errorMessage = _ref2.errorMessage;
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: errorMessage !== '' ? (0, _emotion.cx)('card', _commonStyles.tenPxMarginBottom, errorBoarder) : (0, _emotion.cx)('card', _commonStyles.tenPxMarginBottom)
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: (0, _emotion.cx)('card-header', _flexStyles.flexParentCenterSpace)
    }, title,
    /*#__PURE__*/
    _react["default"].createElement("div", null, errorMessage !== '' ?
    /*#__PURE__*/
    _react["default"].createElement(_reactComponents.Tooltip, {
      direction: "top",
      contents: errorMessage
    },
    /*#__PURE__*/
    _react["default"].createElement(_IconAlertTriangle["default"], {
      weight: 'fill',
      size: "lg",
      color: _colors.warning.base
    })) : null,
    /*#__PURE__*/
    _react["default"].createElement(IconButton, {
      className: _commonStyles.tenPxMarginLeft,
      type: "link",
      onClick: onEditClick
    },
    /*#__PURE__*/
    _react["default"].createElement(_IconPencilAlt["default"], {
      weight: editing ? 'fill' : 'regular',
      size: "lg",
      color: _colors.teal.base
    })), onCopyClick ?
    /*#__PURE__*/
    _react["default"].createElement(IconButton, {
      className: _commonStyles.tenPxMarginLeft,
      type: "link",
      onClick: onCopyClick
    },
    /*#__PURE__*/
    _react["default"].createElement(_IconCopy["default"], {
      size: "lg",
      color: _colors.teal.base
    })) : null,
    /*#__PURE__*/
    _react["default"].createElement(IconButton, {
      className: _commonStyles.tenPxMarginLeft,
      type: "link",
      onClick: onDeleteClick
    },
    /*#__PURE__*/
    _react["default"].createElement(_IconBin["default"], {
      size: "lg",
      color: _colors.teal.base
    })))), content)
  );
};

ConstraintCard.propTypes = {
  title: _propTypes["default"].node.isRequired,
  content: _propTypes["default"].node.isRequired,
  editing: _propTypes["default"].bool,
  onDeleteClick: _propTypes["default"].func.isRequired,
  onEditClick: _propTypes["default"].func.isRequired,
  onCopyClick: _propTypes["default"].func,
  errorMessage: _propTypes["default"].string
};
ConstraintCard.defaultProps = {
  errorMessage: ''
};
var _default = ConstraintCard;
exports["default"] = _default;